// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavigationMenu from './NavigationMenu';
import {
  Box,
  Avatar,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Drawer,
  AppBar,
  Toolbar,
  Snackbar,
  Alert
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useAuth } from '../context/AuthContext';
import { useBalance } from '../context/BalanceContext';

const Header = () => {
  // AuthContext から認証に関する状態とサインアウト関数を取得
  const { publicKey, authInProgress, authSuccess, authError, handleSignOut,handleSnackbarClose } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  // サインアウト確認用のモーダルの表示状態
  const [signOutModalOpen, setSignOutModalOpen] = useState(false);
  const { fetchBalances,fetchReward } = useBalance();
const [errorBool,setErrorBool] = useState(false);
  // publicKey と Firebase 認証が成功している場合、残高情報の取得を実行（必要に応じて）
  useEffect(() => {
    if (publicKey && authSuccess) {
      fetchBalances();
      fetchReward();
    }
  }, [publicKey, authSuccess]);

  useEffect(() => {
    if (authError !== '') {
      setErrorBool(true);
      const timer = setTimeout(() => {
        setErrorBool(false);
      }, 3000);
  
      // クリーンアップ関数でタイマーをクリアする
      return () => clearTimeout(timer);
    } else {
      setErrorBool(false);
    }
  }, [authError]);
  

  // ウォレットボタンのスタイル（グレー背景）
  const walletButtonStyle = { backgroundColor: '#666666' };

  // サインアウト確認モーダルを表示するハンドラ
  const openSignOutModal = (e) => {
    // アドレス表示部分がクリックされたときのみ反応（ウォレット接続済みの場合）
    if (publicKey) {
      e.stopPropagation();
      setSignOutModalOpen(true);
    }
  };

  // サインアウト実行後、モーダルを閉じる
  const confirmSignOut = async () => {
    await handleSignOut();
    setSignOutModalOpen(false);
  };

  return (
    <>
      {/* 固定ヘッダー */}
      <AppBar
        position="fixed"
        sx={{
          backgroundImage: 'radial-gradient(circle at top, #0f2027 0%, #203a43 50%, #2c5364 100%)',
          borderBottom: '1px solid #ddd',
          zIndex: (theme) => theme.zIndex.drawer + 1, // Drawerより上に表示
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* 左端：ホームリンク（Avatar） */}
          <Link to="/" style={{ margin: 0, padding: 0 }}>
            <Avatar
              src="https://github.com/haradav/AlbertEinstein/blob/main/IMG_8367.png?raw=true"
              alt="Avatar"
              sx={{
                width: 50,
                height: 50,
                border: '2px solid #bbb',
              }}
            />
          </Link>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {publicKey ? (
              // クリック可能にするため、onClick を設定
              <Box
                component="span"
                onClick={openSignOutModal}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  backgroundColor: '#666666',
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  cursor: 'pointer',
                }}
              >
                {authInProgress ? (
                  <CircularProgress size={20} />
                ) : authSuccess ? (
                  <CheckCircleIcon
                    sx={{
                      color: 'green',
                      fontSize: 20,
                      backgroundColor: 'white',
                      borderRadius: '50%',
                    }}
                  />
                ) : null}
                <span style={{ fontWeight: 'bold', fontSize: 16, color: 'white' }}>
                  {publicKey.toString().slice(0, 4)}...{publicKey.toString().slice(-4)}
                </span>
              </Box>
            ) : (
              <WalletMultiButton style={walletButtonStyle} />
            )}
            <IconButton sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  backgroundColor: '#666666',
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  cursor: 'pointer',
                  color:"white"
                }} onClick={() => setMenuOpen(true)}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        PaperProps={{
          sx: { top: '64px' },
        }}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setMenuOpen(false)}
          onKeyDown={() => setMenuOpen(false)}
        >
          <NavigationMenu />
        </Box>
      </Drawer>

      {/* サインアウト確認モーダル */}
      <Dialog open={signOutModalOpen} onClose={() => setSignOutModalOpen(false)}>
        <DialogTitle>Disconnect Wallet</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Disconnect your wallet and sign out from Firebase. Are you sure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSignOutModalOpen(false)}>No</Button>
          <Button onClick={confirmSignOut} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* エラーダイアログ */}
      {/* エラーメッセージ通知 */}
      <Snackbar
  open={errorBool}
  autoHideDuration={6000}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert severity="error" sx={{ width: '100%' }}>
    {authError}
  </Alert>
</Snackbar>

    </>
  );
};

export default Header;
